<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="讲师等级">
        <Select v-model="searchCondition.level_id" clearable style="width:200px">
          <Option v-for="item in levels" :value="item.id" :key="item.id">{{ item.level_name }}</Option>
        </Select>
      </Form-item>
      <Form-item label="约课时间">
        <DatePicker
          :editable="false"
          type="datetime"
          split-panels
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm"
          v-model="start_date"
          style="width: 200px"
        ></DatePicker>
        <DatePicker
          :editable="false"
          type="datetime"
          split-panels
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm"
          v-model="end_date"
          style="width: 200px"
        ></DatePicker>
      </Form-item>
      <Form-item label="讲师名称">
        <Input
          style="width:200px"
          placeholder="请输入讲师名称关键字"
          v-model="searchCondition.teacher_name"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item label="学员名称">
        <Input
          style="width:200px"
          placeholder="请输入学员名称关键字"
          v-model="searchCondition.nickname"
          clearable
          @keydown.native.prevent.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/oto/invite/index"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType="none"
        keyField="teacher_id"
        method="post"
      >
        <template slot-scope="{ row }" slot="c1">
          <Avatar :src="row.avatar" />
          <span>{{row.teacher_name}}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            :to="{name:'TeachOtoCommunication',query:{teacher_id:row.teacher_id,user_id:row.user_id,oto_course_id:row.oto_course_id}}"
          >查看沟通记录-</Button>
          <Button
            type="text"
            size="small"
            :to="{name:'TeachOtoComment',query:{teacher_id:row.teacher_id,user_id:row.user_id,oto_course_id:row.oto_course_id}}"
          >查看互评-</Button>
          <Button type="text" size="small" @click="cancelAppoint(row.oto_course_id)">取消约课</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "TeachOtoAppoint",
  data() {
    return {
      levels: [],
      searchCondition: {
        level_id: "",
        teacher_name: "",
        nickname: "",
        created_at_start: "",
        created_at_end: ""
      },
      start_date: "",
      end_date: "",
      columns: [
        {
          title: "讲师名称",
          slot: "c1",
          minWidth: 150
        },
        {
          title: "课时信息",
          key: "course_time",
          width: 200
        },
        {
          title: "讲师等级",
          key: "level_name",
          minWidth: 120
        },
        {
          title: "约课学员",
          key: "nickname",
          minWidth: 120
        },
        {
          title: "学员手机号",
          key: "mobile",
          width: 150,
          align: "center"
        },
        {
          title: "下单时间",
          key: "order_created_at",
          width: 180,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 250,
          align: "center",
          fixed: "right"
        }
      ]
    };
  },
  async created() {
    this.levels = await this.$http.get("/api/oto/teacher/index");
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.order_created_at = this.$pub.timestampToTime(i.order_created_at);
      });
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.level_id = "";
        this.searchCondition.teacher_name = "";
        this.searchCondition.nickname = "";
        this.searchCondition.created_at_start = "";
        this.searchCondition.created_at_end = "";
        this.start_date = "";
        this.end_date = "";
      } else {
        if (this.start_date) {
          this.searchCondition.created_at_start = this.start_date.format(
            "yyyy-MM-dd hh:mm"
          );
        }
        if (this.end_date) {
          this.searchCondition.created_at_end = this.end_date.format(
            "yyyy-MM-dd hh:mm"
          );
        }
      }
      this.$refs.grid.searchRefresh();
    },
    async cancelAppoint(id) {
      let data = await this.$http.get("/api/oto/invite/cancel/" + id + "/1");
      await this.$promiseConfirm(data);
      await this.$http.get("/api/oto/invite/cancel/" + id + "/0");
      this.$refs.grid.refresh();
    }
  }
};
</script>
